import './App.css';
import * as React from 'react';
import {Rtl,theme} from "./config/design/theme";
import { ThemeProvider } from '@mui/material/styles';
import {RouterProvider} from "react-router-dom";
import {router} from "./main/router";
import { SnackbarProvider,closeSnackbar } from 'notistack';
import {IconButton} from "@mui/material";
import axios from 'axios';
import {useEffect, useState} from "react";
import {defaultVariables} from "./config";
import {setStore} from "trim-redux";
import AppLoader from "./class/components/loaders/AppLoader";
import {loadSetting} from "./config/Security";
import {X} from "lucide-react";
import i18n from "i18next";

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

function App() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function run() {
            await loadData();
            setLoading(false); // Set loading to false after data is loaded
        }
        run();
    }, []);

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const langParam = searchParams.get('lang');

        if (langParam) {
            const validLangs = ['fa', 'ar' , 'tr'];
            if (validLangs.includes(langParam)) {
                localStorage.setItem('language', langParam);
                i18n.changeLanguage(langParam);
                document.dir = langParam === 'fa' || langParam === 'ar' ? 'rtl' : 'ltr';
                document.documentElement.lang = langParam;
            }

            // Remove the lang query param from URL
            searchParams.delete('lang');
            const newUrl =
                window.location.pathname +
                (searchParams.toString() ? '?' + searchParams.toString() : '') +
                window.location.hash;
            window.history.replaceState({}, '', newUrl);
        }
    }, []);


    const loadData = async () => {
        const loginToken = localStorage.getItem('ACT');
        if (loginToken) {
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariables.url}/auth/check-login`, config)
                .then(async response => {
                    await setStore({
                        isAuth: true,
                        user: response.data,
                    });
                    await loadSetting(); // Load settings after authentication
                })
                .catch(async error => {
                    await setStore({
                        isAuth: false,
                        user: null,
                    });
                    await loadSetting();
                });
        } else {
            setStore({
                isAuth: false,
                user: null,
            });
            await loadSetting();
        }
    };

    // Render a loading indicator while data is loading

    if (loading) {
        return <AppLoader/>;
    }
    return (
        <React.StrictMode>
            <Rtl>
                <ThemeProvider theme={theme}>
                    <SnackbarProvider
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        action={(snackbarId) => (
                            <IconButton onClick={() => closeSnackbar(snackbarId)}>
                                <X className="lucide-icon"/>
                            </IconButton>
                        )}
                    >
                            <RouterProvider router={router} />
                    </SnackbarProvider>
                </ThemeProvider>
            </Rtl>
        </React.StrictMode>
    );
}

export default App;
